import { FileUploadDataSchema } from "@qw/ui";
import { z } from "zod";

export const ChatFormSchema = z.object({
  text: z.string(),
  files: z.array(FileUploadDataSchema),
});

export type ChatFormValues = z.infer<typeof ChatFormSchema>;
